import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inquire-now',
  templateUrl: './inquire-now.component.html',
  styleUrls: ['./inquire-now.component.css']
})
export class InquireNowComponent implements OnInit {

  constructor(private CommonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }


  ngOnInit() {
    let toUrl = this.generalService.REDIRECT_URL;
    this.CommonScriptComponent.onLoad();
    window.setTimeout(function () {
      window.location.href = toUrl;
    }, 5000)
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/inquire-now/inquire-now.component.ts